import axios, { API_URL } from './BaseService';

export async function doLogin(email, password) {
    const loginUrl = `${API_URL}/login`;
    // O header X-App-Origin é adicionado automaticamente pelo BaseService
    const response = await axios.post(loginUrl, { email, password });
    return response.data;
}

export async function doLogout() {
    const logoutUrl = `${API_URL}/logout`;
    const response = await axios.post(logoutUrl, {});
    return response.data;
}

export async function requestPasswordReset(email) {
    const forgotPasswordUrl = `${API_URL}/forgot-password`;
    const response = await axios.post(forgotPasswordUrl, { email });
    return response.data;
}

export async function resetPassword(token, password) {
    const resetPasswordUrl = `${API_URL}/reset-password`;
    const response = await axios.post(resetPasswordUrl, { token, password });
    return response.data;
}

export async function register(name, email, password, inviteCode) {
    const registerUrl = `${API_URL}/register`;
    const response = await axios.post(registerUrl, { name, email, password, inviteCode });
    return response.data;
}